import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Phone2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M29.35 21.6333C27.3 21.6333 25.3167 21.3 23.4667 20.7C23.1768 20.6024 22.8653 20.5881 22.5677 20.6588C22.2701 20.7295 21.9983 20.8824 21.7833 21.1L19.1667 24.3833C14.45 22.1333 10.0333 17.8833 7.68333 13L10.9333 10.2333C11.3833 9.76667 11.5167 9.11667 11.3333 8.53333C10.7167 6.68333 10.4 4.7 10.4 2.65C10.4 1.75 9.65 1 8.75 1H2.98333C2.08333 1 1 1.4 1 2.65C1 18.1333 13.8833 31 29.35 31C30.5333 31 31 29.95 31 29.0333V23.2833C31 22.3833 30.25 21.6333 29.35 21.6333Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
